import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { GoldRule } from './GoldRule';
import { useLanguage } from './i18n/LanguageContext';
export function Reviews() {
  const {
    t
  } = useLanguage();
  return <section id="resenas" className="max-w-2xl mx-auto px-6 pt-16 scroll-mt-24" data-id="element-325" data-mp="2ma46gfame3s5">
      <GoldRule data-id="element-326" data-mp="2rbl3fzpzh63g">{t.reviews.rule}</GoldRule>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.7
    }} data-id="element-327" data-mp="2r8ffint3ca9b">
        <div className="flex items-center gap-2 mb-3" data-id="element-328" data-mp="352ghdqfcaddw">
          <span className="flex items-center gap-0.5 text-champagne" data-id="element-329" data-mp="352ykn70f5rvb">
            {Array.from({
            length: 5
          }).map((_, i) => <Star key={i} className="w-3 h-3 fill-current" strokeWidth={0} data-id="element-330" data-mp="3f0cs4h4d76bh" data-mpi={i} />)}
          </span>
          <p className="font-body font-semibold text-[11px] tracking-[3px] uppercase text-champagne-deep" data-id="element-331" data-mp="3jzgxsxs2ylx2">
            {t.reviews.badge}
          </p>
        </div>
        <h2 className="font-serif text-dark text-3xl sm:text-4xl leading-tight mb-6" data-id="element-332" data-mp="2re8in0spxzj3">
          {t.reviews.titleTop}
          <br data-id="element-333" data-mp="2mfnlja8rjvyv" />
          <em className="italic text-gold" data-id="element-334" data-mp="2hehrn93da2nr">{t.reviews.titleBottom}</em>
        </h2>
      </motion.div>

      <div className="space-y-5" data-id="element-335" data-mp="2dcw854wbuq4l">
        {t.reviews.items.map((review, i) => <motion.div key={review.meta} initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        delay: i * 0.08
      }} className="bg-cream border-t-2 border-metallic-border p-6 sm:p-7" data-id="element-336" data-mp="2depgqpqi3kf8" data-mpi={i}>
            <span className="flex items-center gap-0.5 text-champagne mb-2" data-id="element-337" data-mp="2wcju1fynwi3f">
              {Array.from({
            length: 5
          }).map((_, s) => <Star key={s} className="w-3.5 h-3.5 fill-current" strokeWidth={0} data-id="element-338" data-mp="3suxyie0uvaz0" data-mpi={s} />)}
            </span>
            <p className="font-serif italic text-dark text-base sm:text-lg leading-[1.65] mb-3" data-id="element-339" data-mp="3o0tplp814sva">
              {review.text}
            </p>
            <div className="font-body font-medium text-[11px] tracking-[2px] uppercase text-soft" data-id="element-340" data-mp="1r50in7qddvn9">
              {review.meta}
            </div>
            <div className="font-body font-light text-[11px] text-champagne-deep mt-0.5" data-id="element-341" data-mp="1cf1jp2qzqg6q">
              {review.service}
            </div>
            <div className="font-serif text-champagne-deep text-base mt-1.5" data-id="element-342" data-mp="13ewhr84kg9zy">{review.amount}</div>
          </motion.div>)}
      </div>
    </section>;
}